import React, {useState, useEffect} from "react";
import {Container, TextField, Dialog, CircularProgress, Slide} from "@material-ui/core";
import {MuiThemeProvider} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MUIDataTable from "mui-datatables";
import {datatableTheme} from "assets/css/datatable-theme.js";
import axios from "axios";
import Moment from "react-moment";
import CustomToolbar from "../../CustomToolbar";
import FilterComponent from "./Components/FilterComponent.js";
import {getCookie} from "../../components/auth/Helpers";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CabinetsReport = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]); //table items
  const [columns, setColumns] = useState(); //for modal2
  const [filterDialog, setFilterDialog] = useState(false);
  const [pagingInfo, setPagingInfo] = useState({page: 0, limit: 20, skip: 0, count: 20}); //Pagination Info
  const [searchEntry, setSearchEntry] = useState([]); //searchEntry

  const [cabinetDialog, setCabinetDialog] = useState(false);
  const [cabinetDialogData, setCabinetDialogData] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const openCabinetsDialog = async (typeId, status, code) => {
    setCabinetDialog(true);
    setSelectedType(code);
    setSelectedStatus(status);

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/filtered_cabinets`, {
      params: {type: typeId, status},
      headers: {Authorization: `Bearer ${token}`},
    });

    setCabinetDialogData(response.data);
  };

  const getFormattedDates = () => {
    const today = new Date();

    const formatDate = (date) => {
      return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
    };

    const currentDate = formatDate(today);

    // Create a new date object for one month before
    const lastMonth = new Date(today);
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    const oneMonthBefore = formatDate(lastMonth);

    return {currentDate, oneMonthBefore};
  };

  const {currentDate, oneMonthBefore} = getFormattedDates();

  const [formFilterValues, setFormFilterValues] = useState({
    client: "",
    fridgesType: "",
    operationType: "",
    status: "",
    fromDate: oneMonthBefore,
    toDate: currentDate,
  });

  useEffect(() => {
    const fetchData = async () => {
      await axios(`${process.env.REACT_APP_BASE_URL}/reports/cabinets`, {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      })
        .then((response) => {
          setItems(response.data);
          return setIsLoading(false);
          return;

          let groupedData = [];

          let lastOperation = null;

          response.data.forEach((item) => {
            if (item.operation_type !== lastOperation) {
              // Add a "header row" for the operation_type
              groupedData.push({
                isHeader: true,
                operation_type: item.operation_type,
              });
              lastOperation = item.operation_type;
            }
            // Add the actual row
            groupedData.push({...item, isHeader: false});
          });

          setItems(groupedData);
        })
        .catch((error) => {
          console.log("error", error);
        });
    };
    fetchData();
  }, [searchEntry]);

  useEffect(() => {
    setColumns([
      {
        name: "_id",
        options: {
          display: false,
        },
      },

      {label: "Code", name: "code"},
      {label: "Type", name: "door_type"},

      ...["Operational", "Quarantine", "Major Maintenance", "Damaged", "Discontinued"].map((statusLabel) =>
        //   {
        //   label: statusLabel,
        //   name: "statusCounts",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return (
        //         <div>
        //           <span>{value && value[statusLabel] ? value[statusLabel] : 0}</span>
        //         </div>
        //       );
        //     },
        //   },
        // }
        ({
          label: statusLabel,
          name: "statusCounts",
          options: {
            customBodyRender: (value, tableMeta) => {
              const rowData = items[tableMeta.rowIndex];

              const count = value && value[statusLabel] ? value[statusLabel] : 0;

              return (
                <span
                  style={{
                    cursor: "pointer",
                    color: "#1E88E5",
                    fontWeight: "bold",
                  }}
                  onClick={() => openCabinetsDialog(tableMeta.rowData[0], statusLabel, tableMeta.rowData[1])}
                >
                  {count}
                </span>
              );
            },
          },
        })
      ),
      {label: "Total", name: "total"},
    ]);
  }, []);

  const options = {
    selectableRows: "none",
    filter: false,
    onRowsDelete: null,
    rowsPerPage: pagingInfo.limit,
    rowsPerPageOptions: [20, 50, 100],
    selectToolbarPlacement: "replace",
    // customToolbar: () => {
    //   return <CustomToolbar handleFilter={handleFilter} />;
    // },
    serverSide: true,
    count: pagingInfo.count, // Use total number of items
    page: pagingInfo.page,

    setRowProps: (row, dataIndex, rowIndex) => {
      const rowData = items[rowIndex];

      if (rowData.isHeader) {
        return {
          style: {
            backgroundColor: "#d0e0ff",
            fontWeight: "bold",
          },
        };
      } else {
        return {
          style: {
            backgroundColor: "#fff",
          },
        };
      }
    },

    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPagingInfo({...pagingInfo, page: tableState.page, skip: tableState.page * pagingInfo.limit});
      } else if (action === "changeRowsPerPage") {
        setPagingInfo({...pagingInfo, limit: tableState.rowsPerPage});
      }
    },
  };
  const handleFilter = () => {
    setFilterDialog(true);
  };
  //Search component ---------------START--------------
  const handleChangeSearch = (e, newValue) => {
    setSearchEntry(newValue);
  };
  //Search component ---------------END--------------
  return (
    <>
      <Container maxWidth="xl">
        {/* <Autocomplete
          multiple
          freeSolo
          limitTags={3}
          id="tags-standard"
          options={[]}
          getOptionLabel={(option) => option}
          onChange={handleChangeSearch}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder="Search Data"
              label="Filter by Job #, Operation # and Serial #"
            />
          )}
        /> */}
        {!isLoading ? (
          <MuiThemeProvider theme={datatableTheme}>
            <MUIDataTable title="" data={items} columns={columns} options={options} />
          </MuiThemeProvider>
        ) : (
          <CircularProgress size={30} className="pageLoader" />
        )}
      </Container>
      {/*********************** FILTER start ****************************/}
      <Dialog
        onClose={() => setFilterDialog(false)}
        maxWidth={"xl"}
        fullWidth
        aria-labelledby="customized-dialog-title"
        open={filterDialog}
      >
        <FilterComponent
          formFilterValues={formFilterValues}
          setFormFilterValues={setFormFilterValues}
          setOpenDialog={setFilterDialog}
          setItems={setItems}
          setPagingInfo={setPagingInfo}
          pagingInfo={pagingInfo}
          daily={true}
        />
      </Dialog>

      <Dialog
        open={cabinetDialog}
        onClose={() => setCabinetDialog(false)}
        maxWidth="lg"
        fullWidth
        TransitionComponent={Transition}
      >
        <div style={{padding: 20}}>
          <h2>
            Type: {selectedType} | Status: {selectedStatus}
          </h2>

          {!cabinetDialogData.length ? (
            <p>No cabinets found.</p>
          ) : (
            <MUIDataTable
              title=""
              data={cabinetDialogData}
              columns={[
                {label: "Serial", name: "sn"},

                {label: "Condition", name: "condition"},
                {label: "Location", name: "location"},
                {
                  label: "Created",
                  name: "createdAt",
                  options: {
                    customBodyRender: (value) => <Moment format="YYYY-MM-DD">{value}</Moment>,
                  },
                },
              ]}
              options={{selectableRows: "none"}}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};
export default CabinetsReport;
